const sortOptions = [
    { value: "-created", label: "Mais recentes" },
    { value: "-likesTotal", label: "Mais curtidas" },
    { value: "-answersTotal", label: "Mais respondidas" }
];

export default sortOptions;
